import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = { class: "timeline-wrapper" };
const _hoisted_2 = { class: "stepper" };
const _hoisted_3 = { class: "status text-body-1 font-weight-regular" };
const _hoisted_4 = { class: "body2-text time" };
const _hoisted_5 = { class: "history-btn" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_stepper_item = _resolveComponent("v-stepper-item");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_v_stepper_header = _resolveComponent("v-stepper-header");
    const _component_v_stepper = _resolveComponent("v-stepper");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_HistoryDialog = _resolveComponent("HistoryDialog");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" 스테퍼 "),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_stepper, {
                "non-linear": "",
                elevation: "0",
                "bg-color": "transparent"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_stepper_header, null, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, key) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    true
                                        ? (_openBlock(), _createBlock(_component_v_stepper_item, {
                                            key: `order-detail-step-${key}`,
                                            "complete-icon": _ctx.setCompleteIcon(step.status, step.isComplete),
                                            complete: step.isActive,
                                            color: step.color,
                                            step: "",
                                            class: "pa-0 ta-l"
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(step.status)), 1 /* TEXT */),
                                                _createElementVNode("div", _hoisted_4, _toDisplayString(step.time), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["complete-icon", "complete", "color"]))
                                        : _createCommentVNode("v-if", true),
                                    (!_ctx.isLastDivider(key))
                                        ? (_openBlock(), _createBlock(_component_v_divider, {
                                            key: key + 'divider',
                                            class: "mx-2 step-divider"
                                        }))
                                        : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _createCommentVNode(" 상세이력 다이얼로그 "),
        _createVNode(_component_HistoryDialog, {
            "order-id": _ctx.order && _ctx.order.orderId
        }, {
            activator: _withCtx((props) => [
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_v_btn, _mergeProps(props, {
                        class: "btn-order-history",
                        large: "",
                        variant: "outlined"
                    }), {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('views.order_detail.order_detail_timeline.order_history_detail')), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                ])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["order-id"])
    ]));
}
